import React, { useEffect, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Collapse, Card, CardBody, CardHeader } from "reactstrap"; 
import { MdOutlineChevronRight } from "react-icons/md";
import config from "../../config"; // Assuming config is correctly imported
import { CommonLoader, LoginToken } from "../Utility/common"; // Assuming LoginToken is imported from the correct path

const FAQBlock = () => {
  const returnSkeleton = (randWidth) => {
    return (
      <SkeletonTheme color="#9c9c9c" highlightColor="#c9c9c9">
        <Skeleton height={15} width={randWidth} />
      </SkeletonTheme>
    );
  };

  const [data, setData] = useState();
  const [open, setOpen] = useState("1");
  const [faqAnswers, setFaqAnswers] = useState({});  // To store FAQ answers
  
  const loginToken = LoginToken(); // Assuming LoginToken is a function that gets the token

  // Function to fetch the FAQ answer
  const loadFAQ = (faqId) => {
    return fetch(
      `${config.genni.marketing_portal.API_KEY}/creatorapi/faq?type=public&faqId=${faqId}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json", "x-api-key": loginToken },
      }
    )
      .then((res) => res.ok ? res.json() : Promise.reject(res))
      .then((data) => data?.results?.Answer)
      .catch((error) => {
        console.error("Error fetching FAQ answer:", error);
        return null;  // Handle error and return null
      });
  };

  useEffect(() => {
    // Fetch the FAQ questions list
    fetch(
      `${config.genni.marketing_portal.API_KEY}/creatorapi/faq?type=public`,
      { method: "GET" }
    )
      .then((res) => res.ok ? res.json() : Promise.reject(res))
      .then((data) => {
        if (!data.error) {
          setData(data);
        }
      });
  }, []);

  const toggle = (id) => {
    // Check if the answer is already loaded for the clicked FAQ
    if (!faqAnswers[id]) {
      loadFAQ(id).then((answer) => {
        setFaqAnswers((prevAnswers) => ({
          ...prevAnswers,
          [id]: answer,
        }));
      });
    }
    setOpen(open === id ? "" : id); // Toggle the open state for the clicked FAQ
  };

  return (
    <React.Fragment>
      <div className="card p-3">
        <div className="page-title-box d-flex align-items-center justify-content-between">
          <h2 className="mb-0 madeGentle">FAQs</h2>
        </div>

        {data ? (
          data.results.Row_FaqQuestions.sort((a, b) => a.FaqID - b.FaqID).map((e, i) => {
            return (
              <Card key={e.FaqID}>
                <CardHeader className="cursor-pointer" style={{background:'rgb(247,248,249)'}} onClick={() => toggle(e.FaqID)}>
                  <div className="row-table">
                    <div className="row-group">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                        }}
                      >
                        <h6 className="mb-0" style={{ fontSize: "1rem" }}>
                          {e.Question}
                        </h6>
                      </div>
                    </div>
                    <MdOutlineChevronRight style={{ fontSize: 24, color: "#08090a" }} />
                  </div>
                </CardHeader>

                <Collapse isOpen={open === e.FaqID}>
                  <CardBody>
                    {faqAnswers[e.FaqID] ? (
                      <div dangerouslySetInnerHTML={{
                        __html: faqAnswers[e.FaqID],
                      }}></div> // Display the fetched answer
                    ) : (
                      <div>Loading...</div> // Show loading state while fetching the answer
                    )}
                  </CardBody>
                </Collapse>
              </Card>
            );
          })
        ) : (
          <div>
            <CommonLoader />
          </div> // Show loading state for FAQs
        )}
      </div>
    </React.Fragment>
  );
};

export default FAQBlock;
